import { useCallback } from "react";
import { usePermissions } from "../../../lib/hooks/usePermissions";
import { useGetRole } from "../../../lib/hooks/getRole";
import USER_ROLES from "../../../types/UserRoles";

export const useCanModify = () => {
  const { hasAccessByController } = usePermissions("User");

  const [role] = useGetRole();

  const canModify = useCallback(
    (recordRole: any): boolean => {
      if (hasAccessByController("Modify")) {
        if (role === USER_ROLES.SUPER_ADMIN) {
          return true;
        }
        if (
          role === USER_ROLES.ADMIN &&
          recordRole !== USER_ROLES.SUPER_ADMIN
        ) {
          return true;
        }
        if (
          [USER_ROLES.POSTER, USER_ROLES.SETUP].includes(role) &&
          ![USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN].includes(recordRole)
        ) {
          return true;
        }
      }

      return false;
    },
    [hasAccessByController, role]
  );

  return { canModify };
};
